import React from 'react';

function TestimonialItem2(props) {
    return (
        <div className="col-lg-12">               
            <div className="testimonial-item">            
                <p><span className='i-quote'>"</span> {props.text}<span className='i-quote'>"</span></p>

                <p className="text-sombre"># {props.source}<br></br><span className="text-sombre">{props.date}</span></p>            
            </div>        
        </div> 
    )
}

export default TestimonialItem2;
